module.exports = __webpack_public_path__ + "img/KZ.a9165b1b.svg";